import { queriesPayStatements, queriesPayables } from "@query";
import {
  Payable,
  PayStatement,
  WorkLog,
  WorkLogConvertedResourceType
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Reads the resource an approved work log converted into.
 *
 * A W-2 work log becomes a **pay statement**, a 1099 one a **payable** —
 * `convertedResourceType` is the only thing that says which, and the two ids
 * live in different id spaces. Each read is therefore gated on the matching
 * type: fetching a pay statement through `getPayable` 404s, which is what left
 * the "view"/"cancel" actions inert on the employee side.
 */
export const useQueryWorkLogConvertedResource = (workLog?: WorkLog) => {
  const convertedResourceId = workLog?.convertedResourceId ?? undefined;
  const isPayStatement =
    workLog?.convertedResourceType ===
    WorkLogConvertedResourceType.PAY_STATEMENT;

  const queryPayable = queriesPayables.getPayable.useQuery(
    { payableId: convertedResourceId as string },
    { enabled: !!convertedResourceId && !isPayStatement, retry: false }
  );

  const queryPayStatement = queriesPayStatements.getPayStatement.useQuery(
    { payStatementId: convertedResourceId as string },
    { enabled: !!convertedResourceId && isPayStatement, retry: false }
  );

  return {
    convertedResourceId,
    isPayStatement,
    payable: queryPayable.data as Payable | undefined,
    payStatement: queryPayStatement.data as PayStatement | undefined,
    queryPayable,
    queryPayStatement
  };
};
